import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface FormStateEntry {
  [fieldName: string]: string | number
}
export interface FormState {
  [formName: string]: FormStateEntry
}

export const loadState = () => {
  const serializedState = localStorage.getItem('formData')

  if (!serializedState) return {}

  return JSON.parse(serializedState)
}

export const formsSlice = createSlice({
  name: 'forms',
  initialState: {},
  reducers: {
    setForm: (state, action: PayloadAction<FormStateEntry>) => {
      const { formName } = action.payload
      state[`${formName}`] = [{ ...state[`${formName}`], ...action.payload }]
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .map(({ formName, ...rest }) => rest)
        .shift()

      const serializedState = JSON.stringify(state)
      localStorage.setItem('formData', serializedState)
    },
    resetForm: (state, action) => {
      const formName = action.payload
      const localStorageState = loadState()
      delete state[formName]
      delete localStorageState[formName]

      const serializedState = JSON.stringify(localStorageState)
      localStorage.setItem('formData', serializedState)
    },
    globalResetForm: () => {
      localStorage.removeItem('formData')
      return {}
    },
  },
})

export const { setForm, resetForm, globalResetForm } = formsSlice.actions
